import { capitalize } from './capitalize'
import { firstLetterCapitalize } from './firstLetterCapitalize'
import { secondFormat } from './secondFormat'

export default {
  capitalize,
  firstLetterCapitalize,
  secondFormat
}
